<div class="promo-wrapper pt--24 pb--24" isInViewport (isInViewport)="onInViewChange($event)">
    <ng-container *ngIf="products && products.length > 1">
        <ng-container *ngTemplateOutlet="productIds"></ng-container>
    </ng-container>
    <ng-container *ngIf="singleProduct">
        <ng-container *ngTemplateOutlet="productSingle"></ng-container>
    </ng-container>
</div>

<ng-template #productIds>
    <div class="container-fluid pt--lg-96 pb--lg-96 pt--48 pb--48 position-relative"
        [class.mb--24]="products && products.length > 1">
        <ng-container *ngFor="let product of products">
            <div class="background-overlay" *ngIf="product.image">
                <img *ngIf="product.image" [ngSrc]="product.image" alt="product"
                    class="img-fit img-responsive product-image " fill>
            </div>
            <div class="container d-flex flex-column ">
                <div class="promo-card rounded p--0 col-12 col-lg-6 d-flex flex-column" [ngClass]="_contentAlign">
                    <h2 class="promo-title" [ngClass]="{'text-white text-shadow' : product.image}">{{ product.title }}
                    </h2>
                    <div class="d-flex flex-column promo-description h4"
                        [ngClass]="{'text-white text-shadow' : product.image , _contentAlign}">
                        <div class="promo-content  p--14" [innerHTML]="product.description"></div>
                        <div class="actions">
                            <button class="promo-action" mat-stroked-button color="white" class="mt--24"
                                (click)="goToProduct(product)">{{ 'Scopri di più' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>
<ng-template #productSingle>
    <div class="background-overlay" *ngIf="singleProduct.image">
        <img *ngIf="singleProduct.image" [ngSrc]="singleProduct.image" alt="product"
            class="img-fit img-responsive product-image " fill>
    </div>
    <div class="container d-flex flex-column ">
        <div class="promo-card rounded p--0 col-12 col-lg-6 d-flex flex-column" [ngClass]="_contentAlign">
            <h2 class="promo-title" [ngClass]="{'text-white text-shadow' : singleProduct.image}">{{ singleProduct.title
                }}</h2>
            <div class="d-flex flex-column promo-description"
                [ngClass]="{'text-white text-shadow' : singleProduct.image , _contentAlign}">
                <div class="promo-content  p--14 h4" [innerHTML]="singleProduct.description"></div>
                <div class="actions">
                    <button class="promo-action" mat-stroked-button color="white" class="mt--24"
                        (click)="goToProduct(singleProduct)">{{ 'Scopri di più' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>